import React, { useContext } from "react";
import { StatusContext } from "../../contexts/Status.context";
import MenuList from "../../constants/menu.constants";
import { shuffleNumArray } from "../../utils";
import useTranslation from "../../hooks/useTranslation";

const TrainingMenu: React.FC = () => {
  const { pageStatus, setPageStatus, setEngine, setMechanics, setProblems } =
    useContext(StatusContext);

  const { t } = useTranslation();

  const handlePageStatus = (page: string, index: number) => {
    if (index === 13) {
      window.location.href =
        "https://microexpressionstrainingvideos.com/micro-expressions-training-more/";
    } else {
      setPageStatus(page);
      setEngine("train");
    }
    // if (index !== 16) {
    //   setPageStatus(page);
    // }
    // if (index === 1) {
    //   setEngine("guide");
    // } else if (index === 3) {
    //   setEngine("menu");
    // } else if (index === 13 || index == 14) {
    //   setEngine("practice");
    //   setMechanics(2);
    // } else if (index === 16) {
    // } else if (index === 2 || index === 15) {
    //   setEngine("test");
    //   setMechanics(1);
    // } else {
    //   setEngine("practice");
    //   setMechanics(1);
    // }
  };

  return (
    <div className="">
      <div className="w-full pl-[5%] md:pl-[35%] text-left text-white">
        <div className="text-2xl font-bold my-4">{t("Training menu")}:</div>
        <div className="ml-8">
          <ol className="list-decimal text-lg">
            {MenuList[0].children[2].children?.map((menu, index) => (
              <li
                key={`menu-${index + 1}`}
                className="my-1 cursor-pointer"
                onClick={() => handlePageStatus(menu.shortDesc, index + 1)}
              >
                <span className="hover:border-b">{t(menu.fullDesc)}</span>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default TrainingMenu;
